import type { ChangeEvent } from "react";
import { useState } from "react";

import type { PromptSchema } from "app/pages/activation/components/SetupModal/CompetitorsStep/types";
import { PromptSource } from "app/pages/activation/components/SetupModal/CompetitorsStep/types";

export const useAIInput = () => {
    const [promptText, setPromptText] = useState("");

    const [prompt, setPrompt] = useState<PromptSchema | null>(null);

    const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        e.stopPropagation();
        setPromptText(e.target.value);
    };

    const handleSetPrompt = (prompt: PromptSchema) => {
        setPrompt(prompt);
        setPromptText("");
    };

    const resetPrompt = () => {
        setPrompt(null);
        setPromptText("");
    };

    const onClickChip = (text: string) => {
        setPromptText(text);
        setPrompt({ prompt: text, source: PromptSource.Chip });
    };

    return {
        prompt,
        promptText,
        onChange,
        handleSetPrompt,
        resetPrompt,
        onClickChip,
    };
};
